import * as yup from 'yup';

export const checkoutContactSchema = yup.object({
    phone_number: yup
        .string()
        .required('Vui lòng nhập số điện thoại')
        .test('phone-validation', 'Số điện thoại không hợp lệ', function (value) {
            if (value?.length !== 10) {
                return false;
            }
            const phoneWithoutRegionCodeRegex = /^0[35789]\d{8}\b/g;
            const isValid = phoneWithoutRegionCodeRegex.test(value);
            return isValid;
        }),
});
